const DataCardNotFound = () => {
  return (
    <span className="text-center text-lg font-bold text-system-text-secondary">
      Sem dados
    </span>
  )
}
DataCardNotFound.displayName = 'DataCardNotFound'

export { DataCardNotFound }
